module.exports = {
      id: "android-block-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#android-block",
      toString: function () {
        return this.url;
      }
    }